module.exports = __webpack_public_path__ + "img/more.dfc7dd48.svg";